import Tracking from './src/tracking'
export default Tracking
